import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setSession(data);
    } catch {
      try {
        await api.post("/auth/refresh");
        const { data } = await api.get("/auth/me");
        setSession(data);
      } catch {
        setSession(false);
      }
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const logout = async () => {
    await api.post("/auth/logout");
    setSession(false);
  };

  const setClub = (club) => setSession((s) => ({ ...s, club }));

  return (
    <AuthContext.Provider value={{ session, setSession, logout, setClub, reload: load }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
